import classNames from "classnames"
import React from "react"
import { mapDesigns } from "@mono/mapDesigns"
import MiniBoardCell from "./HistoryBoardCell"

interface MiniBoardProps {
  game: IGame
}

const HistoryBoard: React.FC<MiniBoardProps> = ({ game }) => {
  const map = mapDesigns.find((map) => map.id === game.settings.mapId)
  const lowBrightness = false
  return (
    <div id="history-board" className={`h-auto w-full aspect-square board-${map?.id}`}>
      {map?.cells.map((cell) => (
        <MiniBoardCell game={game} map={map} cell={cell}></MiniBoardCell>
      ))}

      <div
        id="center"
        className={classNames("bg-primary w-full h-full border border-black relative ", {
          "brightness-50": lowBrightness,
        })}
      ></div>
    </div>
  )
}

export default HistoryBoard
